import http from '../http'

/**
 * 添加权限组
 * @param {object} group 权限组,例: {id: 0, pid: 1, name: '名称', summary: '描述', value: ''}
 */
export const addGroup = group => {
    return http.post('/api/groups', group)
}
/**
 * 修改权限组
 * @param {object} group 权限组,例: {id: 0, pid: 1, name: '名称', summary: '描述', value: ''}
 */
export const editGroup = group => {
    return http.put('/api/groups', group)
}



// WEBPACK FOOTER //
// ./src/api/main/api-groups.js